import React, { useEffect, useState } from "react";
import Tarjeta from '../../components/tarjeta/Tarjeta';

export const Home = () => {

	const [menus, setMenus] = useState([]);

	const loadMenus = async () => {
		const  response = await fetch('https://servicios01.uteg.edu.mx/api/uteg/menu_aplicativos', {
                       'mode': 'cors',
	               'headers': {
                            'Access-Control-Allow-Origin': '*',
                       }
                })
		const data  = await response.json()
		setMenus(data)
	}

	useEffect(() => {
		loadMenus()
	}, [])

  return (
   <div>
        <div className="container-fluid">
	    <div className="row">
		{menus.map((menu) => ( 
		   <Tarjeta key={menu.id} imagen={menu.imagen} titulo={menu.nombre} monto={menu.orden} link={menu.enlace} />
		))}
            </div>
	    <div className="row"></div>
        </div>
    </div>
  );
}

export default Home
